<div class="relative p-6 bg-white z-1 dark:bg-gray-900 sm:p-0">
  <div
    class="relative flex flex-col justify-center w-full h-screen lg:flex-row dark:bg-gray-900 sm:p-0"
  >
    <!-- Left Side Hero Section (was Right) -->
    <div
      class="items-center hidden w-full h-full lg:w-1/2 bg-gradient-to-br from-purple-700 via-indigo-600 to-blue-500 dark:from-slate-950 dark:via-blue-950 dark:to-indigo-950 lg:grid relative overflow-hidden"
    >
      <!-- Grid Pattern Background -->
      <div class="absolute inset-0 bg-grid-pattern opacity-10"></div>

      <!-- Decorative Blobs -->
      <div
        class="absolute top-0 left-0 w-96 h-96 bg-white/10 dark:bg-cyan-500/10 rounded-full blur-3xl -translate-y-1/2 -translate-x-1/2"
      ></div>
      <div
        class="absolute bottom-0 right-0 w-96 h-96 bg-purple-400/20 dark:bg-purple-500/10 rounded-full blur-3xl translate-y-1/2 translate-x-1/2"
      ></div>
      <div
        class="absolute top-1/2 left-1/2 w-64 h-64 bg-blue-400/10 dark:bg-blue-500/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"
      ></div>

      <!-- Main Content Container -->
      <div
        class="relative z-10 flex items-center justify-center w-full h-full p-8 xl:p-12"
      >
        <div class="w-full max-w-2xl">
          <!-- Badge -->
          <div
            class="inline-flex items-center gap-2 px-4 py-2 mb-8 bg-white/10 dark:bg-white/5 backdrop-blur-sm border border-white/20 dark:border-white/10 rounded-full"
          >
            <span
              class="flex h-2 w-2 rounded-full bg-cyan-400 animate-pulse"
            ></span>
            <span class="text-sm font-medium text-white/90 dark:text-white"
              >AI Powered EDI Platform</span
            >
          </div>

          <!-- Main Heading -->
          <h1
            class="text-4xl xl:text-5xl 2xl:text-6xl font-bold text-white leading-tight mb-6"
          >
            Welcome to
            <span
              class="block mt-2 bg-gradient-to-r from-yellow-200 via-cyan-300 to-blue-200 dark:from-cyan-400 dark:via-blue-400 dark:to-purple-400 bg-clip-text text-transparent"
            >
              <a routerLink="/" class="block mb-4">
                <img
                  width="231"
                  height="48"
                  src="/images/logo/auth-logo.svg"
                  alt="Logo"
                />
              </a>
            </span>
          </h1>

          <!-- Description -->
          <p
            class="text-lg xl:text-xl text-white/80 dark:text-slate-300 mb-12 leading-relaxed max-w-xl"
          >
            The next generation EDI ecosystem enabling partner onboarding,
            intelligent AI mapping, connectivity management and transaction
            monitoring.
          </p>

          <!-- AI Engine Visualization -->
          <div class="relative">
            <div
              class="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-3xl rounded-full"
            ></div>

            <div class="relative flex items-center justify-center">
              <!-- Input Formats (Left) -->
              <div class="space-y-3">
                <div
                  class="group flex items-center gap-3 px-4 py-3 bg-white/10 dark:bg-white/5 backdrop-blur-sm border border-white/20 dark:border-white/10 rounded-xl hover:bg-white/20 dark:hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-lg"
                >
                  <span class="text-white font-semibold">JSON</span>
                </div>
                <div
                  class="group flex items-center gap-3 px-4 py-3 bg-white/10 dark:bg-white/5 backdrop-blur-sm border border-white/20 dark:border-white/10 rounded-xl hover:bg-white/20 dark:hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-lg"
                >
                  <span class="text-white font-semibold">XML</span>
                </div>
                <div
                  class="group flex items-center gap-3 px-4 py-3 bg-white/10 dark:bg-white/5 backdrop-blur-sm border border-white/20 dark:border-white/10 rounded-xl hover:bg-white/20 dark:hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-lg"
                >
                  <span class="text-white font-semibold">CSV</span>
                </div>
              </div>

              <!-- AI Engine Center -->
              <div class="mx-8 xl:mx-12 relative">
                <div class="relative w-32 h-32 xl:w-40 xl:h-40">
                  <div
                    class="absolute inset-0 rounded-full border-2 border-white/20 dark:border-cyan-500/20 animate-ping"
                    style="animation-duration: 3s"
                  ></div>
                  <div
                    class="absolute inset-2 rounded-full border-2 border-white/30 dark:border-cyan-500/30 animate-ping"
                    style="animation-duration: 2s"
                  ></div>
                  <div
                    class="absolute inset-0 rounded-full bg-gradient-to-br from-cyan-400 via-blue-500 to-purple-600 dark:from-cyan-500 dark:via-blue-600 dark:to-purple-700 flex items-center justify-center shadow-2xl shadow-blue-500/50"
                  >
                    <div class="text-center">
                      <svg
                        class="w-12 h-12 xl:w-16 xl:h-16 text-white mx-auto"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                          d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                        ></path>
                      </svg>
                      <span class="text-sm font-bold text-white/90 mt-1 block"
                        >AI ENGINE</span
                      >
                    </div>
                  </div>
                  <div
                    class="absolute inset-4 rounded-full bg-white/20 blur-xl"
                  ></div>
                </div>
              </div>

              <!-- Output Formats (Right) -->
              <div
                class="flex flex-col justify-center h-full min-h-[200px] gap-4"
              >
                <div class="flex-1"></div>
                <div
                  class="group flex items-center gap-3 px-4 py-3 bg-white/10 dark:bg-white/5 backdrop-blur-sm border border-white/20 dark:border-white/10 rounded-xl hover:bg-white/20 dark:hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-lg"
                >
                  <span class="text-white font-semibold ml-4">X12</span>
                </div>
                <div
                  class="group flex items-center gap-3 px-4 py-3 bg-white/10 dark:bg-white/5 backdrop-blur-sm border border-white/20 dark:border-white/10 rounded-xl hover:bg-white/20 dark:hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-lg"
                >
                  <span class="text-white font-semibold">EDIFACT</span>
                </div>
                <div class="flex-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Side Form Section (was Left via ng-content) -->
    <ng-content></ng-content>

    <!-- Theme Toggle -->
    <div class="fixed z-50 hidden bottom-6 right-6 sm:block">
      <app-theme-toggle-two />
    </div>
  </div>
</div>
